(() => {
  const DEFAULT_DATE = '24.07.2004';
  const DEFAULT_DATE_INPUT = '2004-07-24';
  const DEFAULT_NAME = 'Metin & Aysun';
  const DEFAULT_TITLE = 'İYİ Kİ SEN';
  const TITLE_MAX_LENGTH = 20;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const formatDate = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return match ? `${match[3]}.${match[2]}.${match[1]}` : DEFAULT_DATE;
  };

  const decodeHtmlEntities = (value) => {
    if (typeof value !== 'string') return value;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  };

  const normalizeCartEditProperties = (properties) => {
    if (!properties) return {};
    const normalizeEntry = (result, key, value) => {
      result[decodeHtmlEntities(key)] = decodeHtmlEntities(value);
      return result;
    };

    if (!Array.isArray(properties) && typeof properties === 'object') {
      return Object.entries(properties).reduce((result, [key, value]) => {
        if (Array.isArray(value) && value.length >= 2) return normalizeEntry(result, value[0], value[1]);
        if (value && typeof value === 'object' && value.first) return normalizeEntry(result, value.first, value.last);
        return normalizeEntry(result, key, value);
      }, {});
    }

    if (Array.isArray(properties)) {
      return properties.reduce((result, property) => {
        if (Array.isArray(property) && property.length >= 2) normalizeEntry(result, property[0], property[1]);
        if (property && typeof property === 'object' && property.first) normalizeEntry(result, property.first, property.last);
        return result;
      }, {});
    }

    return {};
  };

  const initIyikiPersonalizer = (root) => {
    if (root.dataset.renaoIyikiReady === 'true') return;
    root.dataset.renaoIyikiReady = 'true';

    const preview = root.querySelector('[data-renao-iyiki-preview]');
    const poster = root.querySelector('.renao-iyiki-poster');
    const photoInput = root.querySelector('[data-renao-iyiki-photo-input]');
    const photoButton = root.querySelector('[data-renao-iyiki-photo-button]');
    const photoAdjust = root.querySelector('[data-renao-iyiki-photo-adjust]');
    const photoPreview = root.querySelector('[data-renao-iyiki-photo-preview]');
    const fileName = root.querySelector('[data-renao-iyiki-file-name]');
    const dateInput = root.querySelector('[data-renao-iyiki-date-input]');
    const dateProperty = root.querySelector('[data-renao-iyiki-date-property]');
    const datePreview = root.querySelector('[data-renao-iyiki-date-preview]');
    const titleInput = root.querySelector('[data-renao-iyiki-title-input]');
    const titlePreview = root.querySelector('[data-renao-iyiki-title-preview]');
    const titleCount = root.querySelector('[data-renao-iyiki-title-count]');
    const nameInput = root.querySelector('[data-renao-iyiki-name-input]');
    const namePreview = root.querySelector('[data-renao-iyiki-name-preview]');
    const nameCount = root.querySelector('[data-renao-iyiki-name-count]');
    const noteInput = root.querySelector('textarea[name="properties[Not]"]');
    const titleFontButtons = root.querySelectorAll('[data-renao-iyiki-title-font-option]');
    const titleFontProperty = root.querySelector('[data-renao-iyiki-title-font-property]');
    const toggleInputs = root.querySelectorAll('[data-renao-iyiki-toggle-target]');
    const photoPosition = root.querySelector('[data-renao-iyiki-photo-position]');
    const proofOpen = root.querySelector('[data-renao-iyiki-proof-open]');
    const proofModal = root.querySelector('[data-renao-iyiki-proof-modal]');
    const proofStage = root.querySelector('[data-renao-iyiki-proof-stage]');
    const proofCloseButtons = root.querySelectorAll('[data-renao-iyiki-proof-close]');
    const cropModal = root.querySelector('[data-renao-iyiki-crop]');
    const cropStage = root.querySelector('[data-renao-iyiki-crop-stage]');
    const cropImage = root.querySelector('[data-renao-iyiki-crop-image]');
    const cropZoom = root.querySelector('[data-renao-iyiki-crop-zoom]');
    const cropApply = root.querySelector('[data-renao-iyiki-crop-apply]');
    const cropCancelButtons = root.querySelectorAll('[data-renao-iyiki-crop-cancel]');
    const cropMoveButtons = root.querySelectorAll('[data-renao-iyiki-crop-move]');
    const cropZoomStepButtons = root.querySelectorAll('[data-renao-iyiki-crop-zoom-step]');
    const cropReset = root.querySelector('[data-renao-iyiki-crop-reset]');
    const previewOriginalParent = preview?.parentElement || null;
    const previewOriginalNext = preview?.nextSibling || null;

    if (!preview || !poster || !photoInput || !photoPreview || !dateInput || !titleInput || !nameInput) return;
    if (proofModal && proofModal.parentElement !== document.body) document.body.appendChild(proofModal);
    if (cropModal && cropModal.parentElement !== document.body) document.body.appendChild(cropModal);
    if (cropImage) cropImage.draggable = false;

    let objectUrl = '';
    let existingPhotoUrl = '';
    let cropState = { scale: 1, x: 0, y: 0 };
    let dragState = null;
    let selectedTitleFont = 'decorative';
    const togglePropertyFields = [
      { target: 'date', field: dateProperty, propertyName: 'properties[Tarih]' },
      { target: 'title', field: titleInput, propertyName: 'properties[Başlık]' },
      { target: 'name', field: nameInput, propertyName: 'properties[İsim]' },
    ];

    const getProductForm = () => root.closest('form');

    const getProductMediaWrapper = () => {
      const product = root.closest('.product') || document.querySelector('.product');
      return product ? product.querySelector('.product__media-wrapper') : null;
    };

    const isOn = (target) => {
      const toggle = root.querySelector(`[data-renao-iyiki-toggle-target="${target}"]`);
      return !toggle || toggle.checked;
    };

    const setPreviewVisibility = (element, isVisible) => {
      if (!element) return;
      element.hidden = false;
      element.classList.toggle('is-preview-hidden', !isVisible);
      element.setAttribute('aria-hidden', String(!isVisible));
    };

    const syncToggleProperties = () => {
      togglePropertyFields.forEach(({ target, field, propertyName }) => {
        if (!field) return;
        if (isOn(target)) {
          field.setAttribute('name', propertyName);
          return;
        }
        field.removeAttribute('name');
      });
    };

    const replayAnimation = (element, className, duration = 640) => {
      if (!element) return;
      element.classList.remove(className);
      void element.offsetWidth;
      element.classList.add(className);
      window.setTimeout(() => element.classList.remove(className), duration);
    };

    const setEditSubmitText = (productForm, attempt = 0) => {
      if (!productForm) return;
      const submitButtonText = productForm.querySelector('[type="submit"] span');
      if (submitButtonText) {
        submitButtonText.textContent = 'Düzenlemeyi Bitir';
        return;
      }
      if (attempt < 12) window.setTimeout(() => setEditSubmitText(productForm, attempt + 1), 80);
    };

    const setToggleState = (target, isEnabled) => {
      const toggle = root.querySelector(`[data-renao-iyiki-toggle-target="${target}"]`);
      if (toggle) toggle.checked = isEnabled;
    };

    const applyGiftWrapEditValue = (productForm, value) => {
      if (!productForm || value === undefined) return;
      const giftWrapSelect = productForm.querySelector('[data-renao-gift-wrap-select]');
      if (!giftWrapSelect) return;
      const option = Array.from(giftWrapSelect.options).find((item) => item.value === value);
      if (option) giftWrapSelect.value = option.value;
    };

    const setExistingPhotoProperty = (url) => {
      const form = getProductForm();
      if (!form) return;
      let input = form.querySelector('[data-renao-iyiki-existing-photo-property]');
      if (!url) {
        input?.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Fotoğraf]';
        input.dataset.renaoIyikiExistingPhotoProperty = '';
        form.appendChild(input);
      }
      input.value = url;
    };

    const clampPhotoPosition = () => {
      const maxX = Math.max(0, (cropState.scale - 1) / 2);
      const maxY = Math.max(0, (cropState.scale - 1) / 2);
      cropState.x = clamp(cropState.x, -maxX, maxX);
      cropState.y = clamp(cropState.y, -maxY, maxY);
    };

    const getPhotoTransformForStage = (targetStage) => {
      const targetBounds = targetStage?.getBoundingClientRect();
      const targetWidth = targetBounds?.width || 1;
      const targetHeight = targetBounds?.height || 1;
      return `translate3d(${cropState.x * targetWidth}px, ${cropState.y * targetHeight}px, 0) scale(${cropState.scale})`;
    };

    const updateHiddenPhotoState = () => {
      if (!photoPosition) return;
      const nextState = {
        scale: Number(cropState.scale.toFixed(3)),
        x: Number(cropState.x.toFixed(4)),
        y: Number(cropState.y.toFixed(4)),
      };
      photoPosition.value = globalThis.RenaoCropRecipe?.mergeJson
        ? globalThis.RenaoCropRecipe.mergeJson(photoPosition.value, nextState, photoPreview, photoPreview?.parentElement)
        : JSON.stringify(nextState);
    };

    const applyPhotoTransform = () => {
      clampPhotoPosition();
      photoPreview.style.transform = getPhotoTransformForStage(photoPreview.parentElement);
      if (cropImage) cropImage.style.transform = getPhotoTransformForStage(cropImage.parentElement);
      updateHiddenPhotoState();
    };

    const hasPhoto = () => Boolean(objectUrl || existingPhotoUrl || (photoInput.files && photoInput.files.length));

    const syncPhotoState = () => {
      poster.classList.toggle('has-photo', hasPhoto());
      root.classList.toggle('has-renao-iyiki-photo-error', false);
      if (fileName) {
        const selectedFile = photoInput.files && photoInput.files[0];
        fileName.textContent = selectedFile?.name
          || (existingPhotoUrl ? existingPhotoUrl.split('/').pop() : 'Yükledikten sonra yakınlaştırıp konumlandırabilirsin.');
      }
      if (photoAdjust) photoAdjust.hidden = !hasPhoto();
      applyPhotoTransform();
    };

    const setPhotoSource = (src) => {
      if (!src) return;
      photoPreview.src = src;
      if (cropImage) cropImage.src = src;
      syncPhotoState();
    };

    const setSelectedFile = (file) => {
      if (!file) return;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(file);
      existingPhotoUrl = '';
      setExistingPhotoProperty('');
      cropState = { scale: 1, x: 0, y: 0 };
      setPhotoSource(objectUrl);
      window.requestAnimationFrame(openCrop);
    };

    const syncText = () => {
      const dateValue = formatDate(dateInput.value || DEFAULT_DATE_INPUT);
      const datePropertyValue = formatDate(dateInput.value);
      const normalizedTitle = String(titleInput.value || '')
        .toLocaleUpperCase('tr-TR')
        .slice(0, TITLE_MAX_LENGTH);
      const nameValue = String(nameInput.value || DEFAULT_NAME).trim() || DEFAULT_NAME;
      const titleLength = (normalizedTitle.trim() || DEFAULT_TITLE).length;
      const titleFontSize = clamp(130 - Math.max(0, titleLength - 9) * 6, 64, 130);
      if (titleInput.value !== normalizedTitle) titleInput.value = normalizedTitle;
      dateProperty.value = datePropertyValue;
      datePreview.textContent = dateValue;
      titlePreview.textContent = normalizedTitle.trim() || DEFAULT_TITLE;
      poster.style.setProperty('--rn-iyiki-title-font-size', `${titleFontSize}px`);
      namePreview.textContent = nameValue;
      setPreviewVisibility(datePreview, isOn('date'));
      setPreviewVisibility(titlePreview.closest('.renao-iyiki-poster__title'), isOn('title'));
      setPreviewVisibility(namePreview.closest('.renao-iyiki-poster__names'), isOn('name'));
      syncToggleProperties();
      if (titleCount) titleCount.textContent = `${titleInput.value.length}/${titleInput.maxLength}`;
      if (nameCount) nameCount.textContent = `${nameInput.value.length}/${nameInput.maxLength}`;
      root.classList.remove('has-renao-iyiki-date-error', 'has-renao-iyiki-name-error');
    };

    const setTitleFont = (fontKey) => {
      selectedTitleFont = fontKey || 'decorative';
      poster.dataset.renaoIyikiTitleFont = selectedTitleFont;
      titleFontButtons.forEach((button) => {
        const isSelected = button.dataset.renaoIyikiTitleFontOption === selectedTitleFont;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        if (isSelected && titleFontProperty) {
          titleFontProperty.value = button.dataset.renaoIyikiTitleFontLabel || 'Dekoratif';
        }
      });
    };

    const showProductMedia = () => {
      const mediaWrapper = getProductMediaWrapper();
      if (mediaWrapper) {
        mediaWrapper.classList.remove('has-renao-live-preview');
        mediaWrapper.classList.remove('is-renao-media-returning');
        void mediaWrapper.offsetWidth;
        mediaWrapper.classList.add('is-renao-media-returning');
        window.setTimeout(() => mediaWrapper.classList.remove('is-renao-media-returning'), 900);
      }

      root.classList.remove('has-renao-live-preview');
      if (previewOriginalParent && preview.parentElement !== previewOriginalParent) {
        previewOriginalParent.insertBefore(preview, previewOriginalNext);
      }
      preview.hidden = true;
    };

    const ensureLivePreviewDock = (mediaWrapper) => {
      let dock = mediaWrapper.querySelector('[data-renao-iyiki-live-preview-dock]');
      if (dock) return dock;

      dock = document.createElement('div');
      dock.className = 'renao-live-preview-dock renao-live-preview-dock--iyiki';
      dock.dataset.renaoIyikiLivePreviewDock = '';
      dock.innerHTML = `
        <div class="renao-live-preview-dock__bar">
          <span class="renao-live-preview-dock__title">
            <span class="renao-live-preview-dock__mark" aria-hidden="true"></span>
            <span>
              <strong>Canlı önizleme</strong>
              <small>Baskıdan önceki son tasarım</small>
            </span>
          </span>
          <button type="button" data-renao-iyiki-show-product-media>Ürün fotoğrafları</button>
        </div>
        <div class="renao-live-preview-dock__slot" data-renao-iyiki-live-preview-slot></div>
      `;
      mediaWrapper.insertBefore(dock, mediaWrapper.firstChild);
      dock.querySelector('[data-renao-iyiki-show-product-media]')?.addEventListener('click', showProductMedia);
      return dock;
    };

    const showLivePreview = () => {
      const mediaWrapper = getProductMediaWrapper();
      if (!mediaWrapper) return;

      const dock = ensureLivePreviewDock(mediaWrapper);
      const slot = dock.querySelector('[data-renao-iyiki-live-preview-slot]');
      if (!slot) return;

      if (preview.parentElement !== slot) slot.appendChild(preview);
      preview.hidden = false;
      mediaWrapper.classList.remove('is-renao-media-returning');
      mediaWrapper.classList.add('has-renao-live-preview');
      root.classList.add('has-renao-live-preview');
    };

    const activateLivePreview = (event) => {
      if (event?.target?.closest?.('[data-renao-iyiki-crop], [data-renao-iyiki-proof-modal]')) return;
      showLivePreview();
    };

    const openProof = () => {
      if (!proofModal || !proofStage) return;
      proofStage.innerHTML = '';
      const clone = preview.cloneNode(true);
      proofStage.appendChild(clone);
      proofModal.hidden = false;
      document.documentElement.classList.add('renao-proof-modal-open');
    };

    const closeProof = () => {
      if (!proofModal) return;
      proofModal.hidden = true;
      document.documentElement.classList.remove('renao-proof-modal-open');
    };

    const openCrop = () => {
      if (!cropModal || !cropImage || !hasPhoto()) return;
      cropZoom.value = String(cropState.scale);
      cropModal.hidden = false;
      document.documentElement.classList.add('renao-iyiki-crop-open');
      window.requestAnimationFrame(applyPhotoTransform);
    };

    const closeCrop = () => {
      if (!cropModal) return;
      applyPhotoTransform();
      cropModal.hidden = true;
      document.documentElement.classList.remove('renao-iyiki-crop-open');
    };

    const moveCrop = (direction) => {
      const step = 14;
      const bounds = (cropStage || photoPreview.parentElement)?.getBoundingClientRect();
      const stepX = step / (bounds?.width || 1);
      const stepY = step / (bounds?.height || 1);
      if (direction === 'left') cropState.x -= stepX;
      if (direction === 'right') cropState.x += stepX;
      if (direction === 'up') cropState.y -= stepY;
      if (direction === 'down') cropState.y += stepY;
      applyPhotoTransform();
    };

    const resetCrop = () => {
      cropState = { scale: 1, x: 0, y: 0 };
      if (cropZoom) cropZoom.value = '1';
      applyPhotoTransform();
    };

    const validate = () => {
      const missingPhoto = !hasPhoto();
      const missingDate = isOn('date') && !dateProperty.value.trim();
      const missingName = isOn('name') && !nameInput.value.trim();

      root.classList.toggle('has-renao-iyiki-photo-error', missingPhoto);
      root.classList.toggle('has-renao-iyiki-date-error', missingDate);
      root.classList.toggle('has-renao-iyiki-name-error', missingName);

      if (!missingPhoto && !missingDate && !missingName) return true;

      const target = missingPhoto ? photoButton : missingDate ? dateInput : nameInput;
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target?.focus?.({ preventScroll: true });
      return false;
    };

    root.addEventListener('renao:iyiki:validate', (event) => {
      event.detail.valid = validate();
    });

    photoButton?.addEventListener('click', () => {
      showLivePreview();
      photoInput.click();
    });
    photoAdjust?.addEventListener('click', () => {
      showLivePreview();
      openCrop();
    });
    photoInput.addEventListener('change', () => {
      const file = photoInput.files && photoInput.files[0];
      showLivePreview();
      if (file) setSelectedFile(file);
    });

    dateInput.addEventListener('input', () => {
      syncText();
      showLivePreview();
    });
    titleInput.addEventListener('input', () => {
      syncText();
      showLivePreview();
    });
    nameInput.addEventListener('input', () => {
      syncText();
      showLivePreview();
    });
    titleFontButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTitleFont(button.dataset.renaoIyikiTitleFontOption);
        showLivePreview();
        replayAnimation(preview, 'is-title-font-changing');
      });
    });

    toggleInputs.forEach((toggle) => {
      toggle.addEventListener('change', () => {
        syncText();
        showLivePreview();
      });
    });

    proofOpen?.addEventListener('click', () => {
      showLivePreview();
      openProof();
    });
    proofCloseButtons.forEach((button) => button.addEventListener('click', closeProof));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeProof();
        closeCrop();
      }
    });

    cropCancelButtons.forEach((button) => button.addEventListener('click', closeCrop));
    cropApply?.addEventListener('click', closeCrop);
    cropZoom?.addEventListener('input', () => {
      cropState.scale = clamp(Number(cropZoom.value) || 1, 1, 2.8);
      applyPhotoTransform();
    });
    cropZoomStepButtons.forEach((button) => {
      button.addEventListener('click', () => {
        cropState.scale = clamp(cropState.scale + Number(button.dataset.renaoIyikiCropZoomStep || 0), 1, 2.8);
        if (cropZoom) cropZoom.value = String(cropState.scale);
        applyPhotoTransform();
      });
    });
    cropMoveButtons.forEach((button) => {
      button.addEventListener('click', () => moveCrop(button.dataset.renaoIyikiCropMove));
    });
    cropReset?.addEventListener('click', resetCrop);

    cropStage?.addEventListener('pointerdown', (event) => {
      if (!hasPhoto()) return;
      dragState = { x: event.clientX, y: event.clientY, baseX: cropState.x, baseY: cropState.y };
      cropStage.setPointerCapture(event.pointerId);
    });
    cropStage?.addEventListener('pointermove', (event) => {
      if (!dragState) return;
      const bounds = cropStage.getBoundingClientRect();
      cropState.x = dragState.baseX + ((event.clientX - dragState.x) / (bounds.width || 1));
      cropState.y = dragState.baseY + ((event.clientY - dragState.y) / (bounds.height || 1));
      applyPhotoTransform();
    });
    const finishDrag = (event) => {
      if (!dragState) return;
      dragState = null;
      if (cropStage?.hasPointerCapture(event.pointerId)) cropStage.releasePointerCapture(event.pointerId);
    };
    cropStage?.addEventListener('pointerup', finishDrag);
    cropStage?.addEventListener('pointercancel', finishDrag);

    const restoreEditState = () => {
      const editKey = new URL(window.location.href).searchParams.get('renao_edit');
      if (!editKey) return;

      try {
        const payload = JSON.parse(window.sessionStorage.getItem(`renaoCartEdit:${editKey}`) || '{}');
        const props = normalizeCartEditProperties(payload.properties);
        const productForm = getProductForm();
        if (productForm) {
          productForm.dataset.renaoEditKey = payload.key || editKey;
          productForm.dataset.renaoEditStorageKey = `renaoCartEdit:${payload.key || editKey}`;
          setEditSubmitText(productForm);
          productForm.querySelector('[data-renao-edit-token-property]')?.remove();
        }
        if (payload.variantId) {
          const variantInput = productForm?.querySelector('[name="id"]');
          if (variantInput) variantInput.value = payload.variantId;
        }
        if (payload.quantity) {
          const quantityInput = productForm?.querySelector('[name="quantity"]');
          if (quantityInput) quantityInput.value = payload.quantity;
        }
        const hasEditableProperties = Object.keys(props).length > 0;
        if (!hasEditableProperties) return;

        setToggleState('date', props.Tarih !== undefined);
        setToggleState('title', props['Başlık'] !== undefined);
        setToggleState('name', props['İsim'] !== undefined);
        if (props.Tarih) {
          const dateMatch = String(props.Tarih).match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
          dateInput.value = dateMatch ? `${dateMatch[3]}-${dateMatch[2]}-${dateMatch[1]}` : DEFAULT_DATE_INPUT;
        }
        if (props['Başlık']) titleInput.value = props['Başlık'];
        if (props['İsim']) nameInput.value = props['İsim'];
        if (noteInput && Object.prototype.hasOwnProperty.call(props, 'Not')) {
          noteInput.value = String(props.Not || '').slice(0, noteInput.maxLength || 140);
        }
        if (props['Başlık Fontu']) {
          const button = Array.from(titleFontButtons)
            .find((option) => option.dataset.renaoIyikiTitleFontLabel === props['Başlık Fontu']);
          if (button) selectedTitleFont = button.dataset.renaoIyikiTitleFontOption || 'decorative';
        }
        if (props['_Fotoğraf'] || props['Fotoğraf']) {
          existingPhotoUrl = props['_Fotoğraf'] || props['Fotoğraf'];
          setExistingPhotoProperty(existingPhotoUrl);
          setPhotoSource(existingPhotoUrl);
        }
        if (props['_Fotoğraf Konumu']) {
          if (photoPosition) photoPosition.value = String(props['_Fotoğraf Konumu']);
          const parsed = JSON.parse(props['_Fotoğraf Konumu']);
          cropState = {
            scale: clamp(Number(parsed.scale) || 1, 1, 2.8),
            x: clamp(Number(parsed.x) || 0, -0.9, 0.9),
            y: clamp(Number(parsed.y) || 0, -0.9, 0.9),
          };
        }
        applyGiftWrapEditValue(productForm, props['Hediye Paketi']);
      } catch (error) {
        console.warn('Renao iyiki cart edit state could not be restored.', error);
      }
    };

    restoreEditState();
    setTitleFont(selectedTitleFont);
    syncText();
    syncPhotoState();
    preview.hidden = true;
    root.addEventListener('focusin', activateLivePreview);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-renao-iyiki-personalizer]').forEach(initIyikiPersonalizer);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-renao-iyiki-personalizer]').forEach(initIyikiPersonalizer);
  });
})();
